var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyBookingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.06445 6.11621H13.8393",
    stroke: "#6D7279",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.343 1V3.2716",
    stroke: "#6D7279",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55371 1V3.2716",
    stroke: "#6D7279",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4862 2.09082H4.41762C2.31117 2.09082 1 3.22313 1 5.30137V11.5154C1 13.6213 2.31117 14.7743 4.41762 14.7743H10.4791C12.5855 14.7743 13.8967 13.642 13.8967 11.5637V5.26686C13.9038 3.22314 12.5927 2.09082 10.4862 2.09082Z",
    stroke: "#6D7279",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBookingIcon);
export default __webpack_public_path__ + "static/media/myBookingIcon.49c983e8988a69bd5d57bbb514c05491.svg";
export { ForwardRef as ReactComponent };